import { useScrolled } from '@helpers/useScrolled'
import { useEffect, useState } from 'react';

export default function ScrollToTop() {
  const visible = useScrolled(1)
  // const scrollUp = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  const [percentage, setPercentage] = useState(0);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? Math.round((scrollTop / docHeight) * 100) : 0;
      setPercentage(pct);
    };
    handleScroll(); // Set initial value

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
   
    <div
      id="scroll-percentage"
      className={`${percentage > 10 ? "active" : ""} ${percentage >= 100 ? "is-complete" : ""}`}
      style={{
        "--scroll-progress": `${percentage}%`,
      }}
      onClick={scrollUp}
    >
      <span id="scroll-percentage-value">{percentage}%</span>

      {/* <i className="fa-solid fa-chevron-up arrow" aria-hidden="true" /> */}
      <svg className="arrow" width="22" height="25" viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">

        <path d="M0.556131 11.4439L11.8139 0.186067L13.9214 2.29352L13.9422 20.6852L9.70638 20.7061L9.76793 8.22168L3.6064 14.4941L0.556131 11.4439" />
        <path d="M23.1276 11.4999L16.0288 4.40105L15.9991 10.4203L20.1031 14.5243L23.1276 11.4999" />
      </svg>

    </div>
  );
}
